"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (Store) {
    var store = null;
    return function () {
        if (store === null) {
            store = new Store();
        }
        return store;
    };
});
